import { NetworkActionPrefix, ActionType } from '../utils/constants';
import defaults from '../api/defaults';
import { deepAssign } from '../utils';
import { combineReducers, pipeReducers, networkActionReducer } from '../utils/reducerFactory';

const DEFAULT_STATE = {
    finishedSteps: [],
    mobileAppLinkSmsSending: defaults.NetworkObject
};

export default combineReducers({
    finishedSteps: function (state = DEFAULT_STATE.finishedSteps, action) {
        if (action.type === ActionType.FINISH_WELCOME_GUIDE_STEP) {
            let list = state.slice();
            list.push(action.stepIdentifier);
            return list;
        }

        return state;
    },
    mobileAppLinkSmsSending: pipeReducers(
        networkActionReducer(NetworkActionPrefix.SEND_MOBILE_APP_LINK_VIA_SMS_PREFIX, DEFAULT_STATE.mobileAppLinkSmsSending)
    )
});